import { Card } from 'corso-admin-ui';
import { isTruthy } from 'corso-types';
import { formatter } from 'corso-web-lib';
import { Description } from '~/components/DescriptionList';
import OrderReference from '~/components/OrderReference';
import { OrderTracking } from '~/components/tracking/OrderTracking';
import { useShippingClaim } from '~/features/shippingClaimReview/ShippingClaimReviewProvider';
import { useCurrency } from '~/hooks/useCurrency';
import { ShipmentClaimLineItems } from './ShipmentClaimLineItems';

export function ShippingClaimOrderDisplay() {
  const { currencyCode } = useCurrency();
  const {
    originalStoreOrder: {
      orderNo,
      platformAdminUrl,
      createdOn,
      id,
      shippingPrice,
      shippingTitle,
      orderTotal,
      tags,
    },
  } = useShippingClaim();

  if (!orderNo || !platformAdminUrl) return null;

  const descriptions = [
    orderTotal !== undefined && {
      term: 'Order Total',
      details: formatter.currency(orderTotal, currencyCode),
    },
    shippingTitle && { term: 'Shipping Title', details: shippingTitle },
    shippingPrice !== undefined && {
      term: 'Shipping Price',
      details: formatter.currency(shippingPrice, currencyCode),
    },
    tags &&
      tags.length > 0 && {
        term: 'Tags',
        details: tags.join(', '),
      },
  ].filter(isTruthy) satisfies Description[];

  return (
    <Card>
      <OrderReference
        orderNo={orderNo}
        platformAdminUrl={platformAdminUrl}
        createdOn={createdOn}
        descriptions={descriptions}
      />

      <OrderTracking
        storeOrderId={id}
        emptyMessage="No shipments on this order."
        renderLineItems={(shipment) => (
          <ShipmentClaimLineItems shipment={shipment} />
        )}
      />
    </Card>
  );
}
